module.exports = __webpack_public_path__ + "static/img/honor.47b4a66a.png";